import { useQuery } from '../useQuery/useQuery'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export const useDonationPartnerConfig = () => {
  const {
    donationService: { getPartnerConfig }
  } = useServices()

  return useQuery(getPartnerConfig, {})
}
